import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useState } from "react";
import { useI18n } from "i18n";
import sendSignInLinkToEmail from "modules/auth/utils/sendSignInLinkToEmail";
import { useHistory } from "react-router";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useAppDispatch } from "store/hooks";
import { setMagicLinkEmail } from "modules/auth/redux/authSlice";
import { getRemoHosts } from "config";
import { useStyles } from "./styles";
import MagicLinkSignInForm from "../MagicLinkSignInForm";

const MagicLinkSignIn = ({ isSignUp = false }) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { push } = useHistory();
  const styles = useStyles();
  const { t } = useI18n();
  const { redirectTo } = useQueryParams();
  const { addErrorNotification } = useNotificationActions();

  const remoUrls = getRemoHosts();

  return isLoading ? (
    <div className={styles.loaderContainer}>
      <PageLoader message={t("wait")} data-testid="loading" />
    </div>
  ) : (
    <MagicLinkSignInForm
      isSignUp={isSignUp}
      onSubmit={async (email) => {
        setIsLoading(true);

        try {
          await sendSignInLinkToEmail(
            email,
            redirectTo ? redirectTo.toString() : undefined,
            !remoUrls.includes(window.location.host)
              ? window.location.host
              : undefined,
          );

          dispatch(setMagicLinkEmail(email));
          push("/check-email-to-login");
        } catch (error) {
          if (error instanceof Error) {
            addErrorNotification({
              message: t("auth:magic.link.invalid"),
              autoDismiss: 10,
            });
          }
        }
        setIsLoading(false);
      }}
    />
  );
};

export default MagicLinkSignIn;
